// 非官方的scale方法, 但是可以通过dpr重绘 实现css3 transform: scale() 不虚化的完美效果
// 注意: 此方法需要在chart init 之后, setOption之前使用, 否则没有效果
export function scaleChart(chart, scaleRate) {
  if (!scaleRate) {
    return
  }
  // 需要兼容mac retina
  chart._zr.painter.dpr = Math.max(scaleRate * window.devicePixelRatio, 1)
}

// 取得echart渲染引擎
export function getEchartRenderer(platform = 'pc') {
  if (platform === 'mobile') {
    return { renderer: 'svg' }
  }
  return { renderer: 'canvas' }
}

/* 
获取tooltip的scale值
 */
export function getTooltipScale(scaleRate) {
  return Math.min(1 / (1 - ((1 - scaleRate) / 2)), 2)
}
